import createAbTestingAtom from './ab-testing.js'
import { createInMemoryAtom } from '@exodus/atoms'

export const abTestingAtomDefinition = {
  id: 'abTestingAtom',
  type: 'atom',
  factory: createAbTestingAtom,
  dependencies: ['storage'],
  public: true,
}

export const abTestingLoadedAtomDefinition = {
  id: 'abTestingLoadedAtom',
  type: 'atom',
  factory: () => createInMemoryAtom({ defaultValue: false }),
  dependencies: [],
  public: true,
}
